<template lang="pug">
.container-listagem
    el-row
      .container-pesquisa
        p.titulo Pesquisa de demandas
        pesquisa-avancada-demandas-relatorio(
          :painel="painel"
          :filtro="pesquisaAvancada"
        )
        .button-pesquisa
          el-button(type="text" @click="resetPesquisa")
            | Limpar
          el-button(type="primary" @click="pesquisar")
            i.fal.fa-search.iconColor
            | &nbsp Pesquisar

      app-divider-refresh-button(
        label="Listagem de demandas",
        @click="getDemandas",
        :hasButton="true"
        content="Atualizar cadastros"
      )

      modal-visualizar-demanda(
        v-if="modal"
        @closeModal="closeModal"
        @callbackSucesso="callbackModal"
        :idDemanda="idDemanda"
      )

      el-table.table(:data="painel.demandas" size="medium" @sort-change='sortChanged')
        template(slot="empty") Não há registros.
        el-table-column(
          prop='numeroDemanda'
          label='Nº',
          width="100"
          :formatter="Utils.formatEmptyRowNA"
          sortable='custom'
        )

        el-table-column(
          prop='nome'
          label='Nome da demanda',
          width="auto"
          :formatter="Utils.formatEmptyRowNA"
          sortable='custom'
        )

        el-table-column(
          prop='painel.nome'
          label='Painel',
          width="auto"
          :formatter="Utils.formatEmptyRowNA"
          sortable='custom'
        )

        el-table-column(
          prop='estadoDemanda.nome'
          label='Estado',
          width="auto"
          :formatter="Utils.formatEmptyRowNA"
          sortable='custom'
        )

        el-table-column(
          prop='dataEntrega'
          label='Data de entrega',
          width="auto"
        )
          template(slot-scope='scope')
            el-tag(:type="scope.row.dataEntregaJaPassou ? 'danger' : scope.row.demandaAVencer ? 'warning' : 'success'" effect='dark') {{scope.row.dataEntrega}}

        el-table-column(
          prop='prioridade.nome'
          label='Prioridade',
          width="auto"
          sortable='custom'
        )
          template(slot-scope='scope')
            el-tag(v-if="scope.row.prioridade" :style="{'background-color':scope.row.prioridade.codigo, color: 'white', 'border': 'none'}" ) {{scope.row.prioridade.nome}}
            span(v-else) {{Utils.formatEmptyRowNA()}}

        el-table-column(
          label='Responsável',
          width="auto",
          minWidth=120
        )
          template(slot-scope='scope')
            avatar-list(v-if="scope.row.responsaveis && scope.row.responsaveis.length > 0" :data="scope.row.responsaveis" label="pessoa.nomeRazaoSocial")
            span(v-else) {{Utils.formatEmptyRowNA()}}

        el-table-column(
          label='Ações',
          width="auto"
        )
          template(slot-scope='scope')
              button-acoes(:acoes="botoesAcao(scope.row)")
      div(v-if="showTotalListagem").contador-total
        span Total de registros: {{ totalRegistros }}
</template>

<script>
import Utils from '@/utils/utils'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import AvatarList from '@/components/AvatarList'
import Pesquisa from '@/components/Pesquisa'
import cloneDeep from 'lodash/cloneDeep'
import PesquisaAvancadaDemandasRelatorio from '@/screens/demandas/components/PesquisaAvancadaDemandasRelatorio'
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import ModalVisualizarDemanda from '@/screens/demandas/components/ModalVisualizarDemanda'
const { showTotalListagem } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

const FILTRO_EMPTY = {}

const PESQUISA_AVANCADA_EMPTY = {
  id: null,
  paineis: null,
  nome: null,
  responsaveis: null,
  prioridades: null,
  estados: null,
  situacoes: null,
  periodoEntrega: null
}

export default {
  mounted () {
    this.getDemandas()
  },

  mixins: [
    AppNotificacao
  ],

  computed: {
    totalRegistros () {
      return this.painel?.demandas?.length ? this.painel.demandas.length : 0
    }
  },

  data () {
    return {
      modal: false,
      painel: {
        demandas: [],
        criador: {}
      },
      Utils,
      idDemanda: null,
      filtro: cloneDeep(FILTRO_EMPTY),
      pesquisaAvancada: cloneDeep(PESQUISA_AVANCADA_EMPTY),
      showTotalListagem
    }
  },

  methods: {
    ...mapActions({
      findAllByFilter: 'demandas/findAllByFilter'
    }),

    resetPesquisa () {
      this.filtro = cloneDeep(PESQUISA_AVANCADA_EMPTY)
      this.pesquisaAvancada = cloneDeep(PESQUISA_AVANCADA_EMPTY)
      this.getDemandas()
    },

    getDemandas () {
      this.pesquisar()
    },

    setFiltro (filtro) {
      this.resetPesquisa()

      this.pesquisaAvancada = {
        ...this.pesquisaAvancada,
        ...filtro
      }

      this.pesquisar()
    },

    closeModal () {
      this.modal = false
    },

    openModal () {
      this.idDemanda = null
      this.modal = true
    },

    callbackModal () {
      this.modal = false
    },

    visualizar (demanda) {
      this.idDemanda = demanda.id
      this.modal = true
    },

    botoesAcao (demanda) {
      return [
        {
          click: this.visualizar.bind(this, demanda),
          icon: 'visibility',
          title: 'Visualizar demanda',
          active: true
        }
      ]
    },

    getInicialPessoa (nome) {
      return nome.charAt(0).toUpperCase()
    },

    async pesquisar () {
      this.setFiltroAdvancedSearch()

      await this.findAllByFilter(this.filtro).then(data => {
        this.painel.demandas = data
      })

      this.filtro = cloneDeep(FILTRO_EMPTY)
    },

    setFiltroAdvancedSearch (pesquisaSimples) {
      if (this.pesquisaAvancada.nome) {
        this.filtro.nome = pesquisaSimples || this.pesquisaAvancada.nome
      }

      if (this.pesquisaAvancada.responsaveis) {
        this.filtro.responsaveis = this.pesquisaAvancada.responsaveis.map(responsavel => responsavel.id)
      }

      if (this.pesquisaAvancada.prioridades) {
        this.filtro.prioridades = this.pesquisaAvancada.prioridades.map(prioridade => prioridade.id)
      }

      if (this.pesquisaAvancada.estados) {
        this.filtro.estados = this.pesquisaAvancada.estados.map(estado => estado.id)
      }

      if (this.pesquisaAvancada.id) {
        this.filtro.id = this.pesquisaAvancada.id
      }

      if (this.pesquisaAvancada.paineis) {
        this.filtro.paineis = this.pesquisaAvancada.paineis.map(painel => painel.id)
      }

      if (this.pesquisaAvancada.situacoes) {
        this.filtro.situacoes = this.pesquisaAvancada.situacoes
      }

      if (this.pesquisaAvancada.periodoEntrega) {
        this.filtro.dataEntrega = this.pesquisaAvancada.periodoEntrega[0]
        this.filtro.dataEntregaFim = this.pesquisaAvancada.periodoEntrega[1]
      }

      if (this.painel) {
        this.filtro.idPainel = this.painel.id
      }
    },

    sortChanged ({ column, prop, order }) {
      const direcaoMap = {
        'ascending': 'ASC',
        'descending': 'DESC'
      }
      this.filtro.ordem = prop
      this.filtro.ordemDirecao = direcaoMap[order]
      this.pesquisar()
    }
  },

  components: {
    ButtonAcoes,
    AppDividerRefreshButton,
    AvatarList,
    Pesquisa,
    PesquisaAvancadaDemandasRelatorio,
    ModalVisualizarDemanda
  }
}
</script>

<style lang="scss" scoped>
.container {
  justify-content: space-between;
  align-items: center;
}

>>> .el-badge__content {
  background-color: #4e5c6b;
}

.container-pesquisa {
  padding: 40px 0px 40px 0px;
  display: flex;
  flex-direction: column;
  .button-pesquisa{
    margin-top: 20px;
    align-self: flex-end;
  }
}

p {
  font-weight: bold;
  margin-bottom: 20px !important;
}

.container-titulo-pesquisa {
  display: flex;
  padding-bottom: 30px;
  justify-content: flex-end;
}

>>> .el-select__tags-text {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}

.el-select-dropdown {
  max-width: 2px;
}

.el-select-dropdown__item {
  height: 40px;
  padding-right: 40px;
}

>>> .el-card__body{
  padding: 10px 0px 20px 0px;
  .card-header-financeiro {
    display: none;
  }
  .card-body-financeiro {
    padding:0px;
  }
}
.contador-total {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/ListagemDemandasRelatorio.vue